export default __webpack_public_path__ + "static/Content-3-f8ce1e266764fb63b76557f7a29061f1.webm";